module.exports = __webpack_public_path__ + "img/teacher_view_student_real_world_button.074f2bb0.jpg";